module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAAQCAYAAAAbBi9cAAAAAXNSR0IArs4c6QAAAStJREFUOBGdkz9qAkEUxjNiQIiF0dbC0hPkAAoi2OUGHiOFQdQypM4pLAKCpxBBUEsvEIKFTYJOfp+8WTC7/tl98O2befO+HzOzu+6O8N7XSI8oh9LEgeZv59zGAXliMkUPKqJ7dEv80FRGO9TO86ijEvpFL2iCrsHU20EfSN66jtVFSzREW9Rk4WLQ07DeEVnebgCt5KQwQDvUOkfSmvUMzLNiHoHWTJwtaGeJMOoBMrRe3bG8J6DojbEQ29l/iIFyAaTLjgWv85UG7XBMfraGMfmdtV7MQCERpEYZgOwZCqB4o9Y/jhIeZ0HqlRHYp41nCf6odBF0CyCQogsOhaw5gDzH0H+TKszjZdLRBCtwF1VyWtjRK4ZAC1REc5Q1FuFrrkGoZKR8ccTNH2eG0ehFC+0PAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./static/assets/icon-mail@1x.png
// module id = asoZ
// module chunks = 2